<!-- 
  For content setup, please checkout item below:
  /sitecore/content/RACQFormsGroup/RACQForms20/Home/Insurance/Quote/Car/Data/Car/Your quote/insuredAmountPanel 
-->
<template>
  <div>
    <SectionPanel v-bind="$props">
      <template #sectionPanelContent>
        <FormStepInputs
          :step="{
            formInputs,
          }"
        >
          <template #marketValueHelpText>
            <div>
              <RichText
                v-if="!showAgreedValue"
                :field="formInputs.marketValueHelpText.label"
                :class="formInputs.marketValueHelpText?.outerClass?.value"
              />
            </div>
          </template>
          <template #agreedValueHelpText>
            <div>
              <RichText
                v-if="showAgreedValue"
                :field="formInputs.agreedValueHelpText.label"
                :class="formInputs.agreedValueHelpText?.outerClass?.value"
              />
            </div>
          </template>
          <template #vehicleAgreedValue>
            <div>
              <RangeInput
                v-if="showAgreedValue"
                v-bind="formInputs.vehicleAgreedValue"
                :min="{ value: agreedValueRange.min }"
                :max="{ value: agreedValueRange.max }"
                :minLabel="{ value: agreedValueRange.minLabel }"
                :maxLabel="{ value: agreedValueRange.maxLabel }"
              />
            </div>
          </template>
          <template #learnMore>
            <div>
              <RichText
                :field="formInputs.learnMore.label"
                tag="button"
                type="button"
                class="link text-m font-sans"
                @click="showTooltip = true"
              />
            </div>
          </template>
          <template #tooltipContent>
            <div>
              <ModalDialog v-model="showTooltip" :closeOnEsc="true" :showXCloseButton="true" size="tooltip">
                <RichText :field="tooltipContent.title" class="sticky-modal-header" />
                <RichText :field="tooltipContent.content" class="tooltip-body richtext" />
              </ModalDialog>
            </div>
          </template>
        </FormStepInputs>
      </template>
    </SectionPanel>
  </div>
</template>
<script setup lang="ts">
import { onMounted, computed, ref } from 'vue';
import SectionPanel from '../SectionPanel/SectionPanel.vue';
import { ISitecoreFormGenericInput } from '@/interfaces';
import FormStepInputs from '../FormStepInputs/FormStepInputs.vue';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import RangeInput from '../RangeInput/RangeInput.vue';
import { IAgreedValueRange } from '@/interfaces/insurance-quote/agreed-value-range.interface';
import ModalDialog from '../ModalDialog/ModalDialog.vue';
import { QuoteVehicleValuationMethods } from '@/enums/quote-vehicle-valudation-methods.enum';

/** Local state and data properties*/
interface Props extends ISitecoreFormGenericInput {
  description: { value: string };
  valuationMethod: QuoteVehicleValuationMethods;
  agreedValueRange: IAgreedValueRange;
}
const props = defineProps<Props>();

/** Computed Properties */
const showTooltip = ref(false);
const formInputs = computed(() => {
  const inputs: Record<string, ISitecoreFormGenericInput> = {};
  props.fields?.forEach((item) => {
    inputs[item.name] = item;
  });
  return inputs;
});

const showAgreedValue = computed(() => {
  return props.valuationMethod == QuoteVehicleValuationMethods.AGREED_VALUE;
});

const tooltipContent = computed(() => {
  const item = props.fields?.find((item) => item.name == 'tooltipContent') as Record<string, any>;
  return {
    title: item?.title,
    content: item?.content,
  };
});
/** Functions */

/** Lifecycle Hooks */
onMounted(() => {});
</script>
